import { render, staticRenderFns } from "./MenuMovil.vue?vue&type=template&id=bef7104a&"
import script from "./MenuMovil.vue?vue&type=script&lang=js&"
export * from "./MenuMovil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports